import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconBackArrow: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="12"
      viewBox="0 0 15 12"
      {...props}
      fill="none"
    >
      <path
        d="M0.333313 5.77125C0.333313 5.45483 0.568441 5.19334 0.873504 5.15195L0.958313 5.14625L11.945 5.14675L7.97582 1.19381C7.73122 0.950255 7.73037 0.554528 7.97392 0.309926C8.19533 0.0875597 8.54251 0.0666399 8.78757 0.247658L8.8578 0.308022L13.8995 5.32802C13.9317 5.36013 13.9597 5.39487 13.9835 5.43156C13.9902 5.44261 13.997 5.45391 14.0035 5.46543C14.0095 5.47531 14.0149 5.48557 14.0199 5.49594C14.027 5.51103 14.0339 5.52663 14.0401 5.54253C14.0452 5.5548 14.0495 5.56673 14.0533 5.57875C14.058 5.59367 14.0624 5.60956 14.0663 5.62569C14.0691 5.63695 14.0714 5.64779 14.0734 5.65868C14.0762 5.67487 14.0785 5.69163 14.0802 5.70858C14.0817 5.72151 14.0825 5.73433 14.083 5.74715C14.0832 5.75493 14.0833 5.76307 14.0833 5.77125L14.083 5.79546C14.0825 5.80773 14.0817 5.81998 14.0805 5.83221L14.0833 5.77125C14.0833 5.81069 14.0797 5.84928 14.0727 5.88669C14.0711 5.89563 14.0691 5.9048 14.067 5.91393C14.0625 5.93275 14.0574 5.95087 14.0515 5.96863C14.0486 5.97745 14.0452 5.98688 14.0416 5.99624C14.0343 6.01505 14.0264 6.03298 14.0176 6.05044C14.0136 6.05865 14.009 6.06725 14.0043 6.07576C13.9965 6.08964 13.9884 6.10283 13.9799 6.11569C13.9739 6.12479 13.9673 6.13426 13.9603 6.14358L13.9549 6.15079C13.9381 6.17279 13.9198 6.19363 13.9003 6.21319L13.8995 6.21377L8.85784 11.2346C8.61326 11.4782 8.21753 11.4774 7.97396 11.2328C7.75253 11.0104 7.73308 10.6632 7.91513 10.4189L7.97579 10.3489L11.9433 6.39675L0.958313 6.39625C0.613135 6.39625 0.333313 6.11643 0.333313 5.77125Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default IconBackArrow;
